import React from 'react';
import { GameProvider } from './context/GameContext';
import GlobalStyle from './styles/GlobalStyle';
import Game from './pages/Game';

function App() {
  return (
    <GameProvider>
      <GlobalStyle />
      <Game />
    </GameProvider>
  );
}

export default App;
